// changes

const getThresholdValueMeningitis = (level) => {
  switch (level) {
    case 1:
      return {
        category: 'Minimal',
        threshold: '<10',
        color: '#E5FDF7',
        OutlineColor: '#2B9181',
      }
    case 2:
      return {
        category: 'Low',
        threshold: '10-<20',
        color: '#AAC9E4',
        OutlineColor: '#2D6EA3',
      }
    case 3:
      return {
         category: 'Medium',
        threshold: '20-<35',
        color: '#7796CC',
        OutlineColor: '#0E456B',
      }
    case 4:
      return {
         category: 'High',
        threshold: '35-<50',
        color: '#5163AE',
        OutlineColor: '#FFFFFF',
      }
    case 5:
      return {
        category: 'Very High',
        threshold: '>=50',
        color: '#422C88',
        OutlineColor: '#FFFFFF',
      }

    default:
      return {
        category: 'No Data',
        threshold: '0',
        color: '#6D6F70',
        OutlineColor: '#6D6F70',
      }
  }
}

export default getThresholdValueMeningitis